import React from "react";
var __jsx = React.createElement;
import { EncounterFieldInput } from "./encounter-field-input";
import { isEndTimeRequired } from "./validate-date-times";
/** Renders the encounter config fields as a two-column form grid. */
export function EncounterForm(_ref) {
  var config = _ref.config,
    formData = _ref.formData,
    onFieldChange = _ref.onFieldChange,
    invalidFieldNames = _ref.invalidFieldNames;
  return /*#__PURE__*/React.createElement("div", {
    className: "grid grid-cols-1 gap-4 sm:grid-cols-2"
  }, config.fields.filter(function (field) {
    return field.type !== "dynamic" && field.type !== "type_selector";
  }).map(function (field) {
    var _formData$field$name;
    return /*#__PURE__*/React.createElement(EncounterFieldInput, {
      key: field.name,
      field: field,
      dropdowns: config.dropdowns,
      value: (_formData$field$name = formData[field.name]) !== null && _formData$field$name !== void 0 ? _formData$field$name : "",
      onChange: function onChange(value) {
        return onFieldChange(field.name, value);
      },
      invalid: invalidFieldNames === null || invalidFieldNames === void 0 ? void 0 : invalidFieldNames.has(field.name),
      requiredOverride: isEndTimeRequired(config, formData, field)
    });
  }));
}